import { compose } from 'redux';
import { connect } from 'react-redux';
import LCQuestionsView from './LCQuestionsView';
import AvatarView from '../../../common/avatar/avatarView';
import withAvatar from '../../../common/avatar/withAvatar';
import selectors from '../../../rootSelectors';
import { cleanupPassage, fetchLCContent, onSelectAnswer } from '../../lcActions';
import { blockScreen, hideSpinner, showSpinner, unblockScreen } from '../../../common/screen/screenActions';
import { getQuestionIndex } from '../../../common/utils/urlParsers';
import { resetQuestionsAndTimeTrackingState, setIsQuestionCompleted } from '../../../common/questions/questionsActions';
import onNextButtonClick, { playQuestionAndResponses } from './LCQuestionsActions';

const mapStateToProps = (state, ownProps) => {
    const questionIndex = getQuestionIndex(ownProps.match.params) - 1;
    const passageHalfIndex = selectors.getLCPassageHalfIndex(state);

    const comprehensionItem = selectors.getLCComprehensionItem(state, passageHalfIndex, questionIndex);
    const currentContent = selectors.getCurrentLCContent(state, passageHalfIndex);
    return {
        questionIndex,
        comprehensionItem,
        currentContent,
        isScreenBlocked: selectors.getIsScreenBlocked(state),
        isGreyedOut: selectors.getIsScreenGreyedOut(state),
        isSpinnerVisible: selectors.getIsSpinnerVisible(state),
        isDataFetched: selectors.getIsLCDataFetched(state),
        isNextButtonActive: selectors.getIsNextButtonActive(state),
        selectedIndex: selectors.getSelectedIndex(state),
        totalQuestions: selectors.getNumLCComprehensionItems(state, passageHalfIndex),
    };
};

const mapDispatchToProps = (dispatch, ownProps) => {
    const questionIndex = getQuestionIndex(ownProps.match.params) - 1;
    return {
        fetchContent: () => dispatch(fetchLCContent()),
        showSpinner: () => dispatch(showSpinner()),
        hideSpinner: () => dispatch(hideSpinner()),
        selectAnswer: responseIndex => dispatch(onSelectAnswer(responseIndex, questionIndex)),
        setIsQuestionCompleted: isComplete => dispatch(setIsQuestionCompleted(questionIndex, isComplete)),
        onNext: () => {
            dispatch(blockScreen());
            return dispatch(onNextButtonClick(questionIndex))
                .then(() => dispatch(unblockScreen()));
        },
        playQuestionAndResponseAudio: (stimulusAudio, possibleResponses) => {
            dispatch(blockScreen());
            return dispatch(playQuestionAndResponses(stimulusAudio, possibleResponses))
                .then(() => dispatch(unblockScreen()));
        },
        cleanup: () => {
            dispatch(cleanupPassage());
            dispatch(resetQuestionsAndTimeTrackingState());
        }
    };
};

const avatarMapStateToProps = () => ({
    position: AvatarView.Position.LOWER_LEFT,
});

const LCQuestionsContainer = compose(
    connect(mapStateToProps, mapDispatchToProps),
    withAvatar(avatarMapStateToProps),
)(LCQuestionsView);

export default LCQuestionsContainer;
